import React from 'react';
import './LoadingSkeleton.scss';

interface LoadingSkeletonProps {
  type?: 'page' | 'sidebar' | 'content';
}

export const LoadingSkeleton: React.FC<LoadingSkeletonProps> = ({ type = 'page' }) => {
  if (type === 'sidebar') {
    return (
      <div className="loading-skeleton-sidebar">
        <div className="skeleton-search-box"></div>
        <div className="skeleton-tree">
          {[1, 2, 3, 4, 5, 6, 7, 8].map(i => (
            <div key={i} className="skeleton-tree-item" style={{ paddingLeft: `${(i % 3) * 20}px` }}>
              <div className="skeleton-tree-icon"></div>
              <div className="skeleton-tree-text" style={{ width: `${60 + Math.random() * 40}%` }}></div>
            </div>
          ))}
        </div>
      </div>
    );
  }

  if (type === 'content') {
    return (
      <div className="loading-skeleton-content">
        <div className="skeleton-header"></div>
        <div className="skeleton-toolbar"></div>
        <div className="skeleton-body">
          {[1, 2, 3, 4].map(i => (
            <div key={i} className="skeleton-row">
              <div className="skeleton-cell"></div>
              <div className="skeleton-cell"></div>
              <div className="skeleton-cell"></div>
            </div>
          ))}
        </div>
      </div>
    );
  }

  return (
    <div className="loading-skeleton-page">
      <div className="skeleton-layout">
        <div className="skeleton-sidebar-section">
          <LoadingSkeleton type="sidebar" />
        </div>
        <div className="skeleton-content-section">
          <LoadingSkeleton type="content" />
        </div>
      </div>
    </div>
  );
};

export default LoadingSkeleton;
